import { gql } from '@apollo/client';

export default gql`
  mutation CreateParentProducerMutation($parentProducer: ParentProducerInput!) {
    createParentProducer(input: { parentProducer: $parentProducer }) {
      parentProducer {
        parentProducerId
        groupName
      }
    }
  }
`;
